import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { IPermission } from 'common/constant/IPermission';
import { UserService } from 'services/user/user.service';
import { RoutePath } from 'src/app/common/constant/route-path';

@Injectable({
  providedIn: 'root'
})
export class RoleGuardService  {

  constructor(
    private userService: UserService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const permissions: Array<IPermission> = route.data?.['permissions']?.flat(Infinity)
    const valid = !permissions || this.userService.hasPermission(permissions)

    if (valid) {
      return true;
    } else {
      this.router.navigate([RoutePath.Login], {
        queryParams: {
          return: state.url
        }
      });
      return false;
    }
  }
}
